  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
//import getVoucherUser     from "./handleVoucherUser";
//import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_AppVersion = {
  wu_checkAppVersion,
  wu_should_checkAppVersion
};
//----------------------------------------------------------------------------------------------------
function wu_checkAppVersion(reqData) {
  const methName = "wu_checkAppVersion ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/checkAppVersion?platform="+reqData.platform+"&appVersion="+reqData.appVersion;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  //const data = {
  //
  //};
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .get(localUrl, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      if(resData && resData.returnCode===0){
        localStorage.setItem("CheckAppVersion_RetrieveLastDate", new Date());
      }
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_should_checkAppVersion(reqData) {
  //console.log("wu_should_checkAppVersion = "+new Date());
  //console.log("CheckAppVersion_RetrieveLastDate = "+localStorage.getItem("CheckAppVersion_RetrieveLastDate"));

  //nailed for testing:START---inactive
  //return true;
  //nailed for testing:END

  if(api.cache_CheckAppVersion_enabled === false){
    return true;
  }

  let UserWSRetrieveLastDate = new Date(localStorage.getItem("CheckAppVersion_RetrieveLastDate"));
  let dateNow                = new Date();
  if(UserWSRetrieveLastDate===null){
      return true;
  }
  else{
      let secondsDiff = (dateNow.getTime()-UserWSRetrieveLastDate.getTime())/1000;
      let minsDiff    = (secondsDiff/60);
      if(minsDiff<0){minsDiff = -minsDiff;}
      if(minsDiff>api.cache_CheckAppVersion_TTL_min){ return true;  }
      else                                          { return false; }
  }
}
//----------------------------------------------------------------------------------------------------
